<template>
  <mdb-modal class="dark-modal" dark size="lg" scrollable :show="showModal" @close="$emit('close-modal')">
    <mdb-modal-header class="dark-modal-header">
      <mdb-modal-title>FJData AB Privacy Policy</mdb-modal-title>
    </mdb-modal-header>
    
    <mdb-modal-body class="dark-modal-body text-left">
      <p class="summary">
        This privacy policy will explain how our organization uses the personal data we collect from you when you use our website or services.
      </p>
      <h1>Topics</h1>
      <ul>
        <li class="topic">What data do we collect?</li>
        <li class="topic">How do we collect your data?</li>
        <li class="topic">How will we use your data?</li>
        <li class="topic">How do we store your data?</li>
        <li class="topic">Marketing</li>
        <li class="topic">What are your data protection rights?
          <ul>
            <li class="sub-topic">The right to access</li>
            <li class="sub-topic">The right to rectification</li>
            <li class="sub-topic">The right to erasure</li>
            <li class="sub-topic">The right to restrict processing</li>
            <li class="sub-topic">The right to object to processing</li>
            <li class="sub-topic">The right to data portability</li>
          </ul>
        </li>
        <li class="topic">What are cookies?</li>
        <li class="topic">How do we use cookies?</li>
        <li class="topic">What types of cookies do we use?</li>
        <li class="topic">Functionality
          <ul>
            <li class="sub-topic">Advertising</li>
            <li class="sub-topic">How to manage your cookies</li>
          </ul>
        </li>
        <li class="topic">Privacy policies of other websites</li>
        <li class="topic">Changes to our policy</li>
        <li class="topic">How to contact us</li>
        <li class="topic">How to contact the appropriate authorities</li>
      </ul>
        
      <h1>What data do we collect?</h1>
      <p>FJData AB collects the following data:</p>
      <ul>
        <li>Personal identification information</li>
        <ul>
          <li>Company name</li>
          <li>Name</li>
          <li>Email address</li>
          <li>Phone number</li>
          <li>Company address</li>
        </ul>
        <li>Customer interactions, such as email and meetings.</li>
        <li>Service usage statistics.</li>
        <li>Product usage statistics.</li>
      </ul>
      
      <h1>How do we collect your data?</h1>
      <p>You directly provide FJData AB with most of the data we collect. We collect data and process data when you:</p>
      <ul>
        <li>Register for any of our services.</li>
        <li>Place an order for a product or service.</li>
        <li>Contact us using any method.</li>
        <li>Use our view our website or service site via your browser’s cookies.</li>
      </ul>
      
      <h1>How will we use your data?</h1>
      <p>FJData AB collects your data so that we can:</p>
      <ul>
        <li>Process your order</li>
        <li>Manage your account</li>
        <li>Further develop our website, our products and services according to usage statistics and feedback.</li>
        <li>Email you with special offers on other products and services we think you might like.</li>
      </ul>
      <p>When FJData AB processes your order, it may send your data to, and also use the resulting information from, credit reference agencies to prevent fraudulent purchases.</p>
      
      <h1>How do we store your data?</h1>
      <p>FJData AB securely stores your data in our secure servers in Frankfurt. Communication between servers and clients are always encrypted. Encrypted, and password-protected, backups are taken every day following the same strong security rules.</p>
      <p>FJData AB will keep your personally identifiable data for 4 years. We will delete that data by targeting creation dates and removing identifiers if possible, or if not, the data points matching the removal date will be removed.</p>
      
      <h1>Marketing</h1>
      <p>FJData Ab would like to send you information about products and services of ours that we think you might like.<br />
      If you have agrees to receive marketing, you may always opt out at a later date.<br />
      You have the right at any time to stop FJData AB from contacting you for marketing purposes.<br />
      If you no longer wish to be contacted for marketing purposes, please use our contact form.</p>
      
      <h1>What are your data protection rights?</h1>
      <p>FJData AB would like to make sure you are fully aware of all of you data protection rights.<br />
      Every user is entitled to the following:</p>
      <h2>The right to access</h2>
      <p>You have the right to request FJData AB for copies of your personal data. We may charge you a small fee for this service.</p>
      <h2>The right to rectification</h2>
      <p>You have the right to request that FJData AB correct any information you believe is inaccurate. You also have the right to request FJData AB to complete information you believe is incomplete.</p>
      <h2>The right to erasure</h2>
      <p>You have the right to request that FJData AB erase your personal data, under certain conditions.</p>
      <h2>The right to restrict processing</h2>
      <p>You have the right to request that FJData AB restrict the processing of your personal data, under certain conditions.</p>
      <h2>The right to object to processing</h2>
      <p>You have the right to object to FJData AB processing of your personal data, under certain conditions.</p>
      <h2>The right to data portability</h2>
      <p>You have the right to request that FJData AB transfer the data we have collected to another organization, or directly to you, under certain conditions.</p>
      <p>If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us. See the contact section below.</p>
      
      <h1>What are cookies?</h1>
      <p>Cookies are text files placed on your computer to collect standard Internet log information and visitor behavior information. When you visit our websites, we may collect information from your automatically through cookies or similar technology.</p>
      <p>For further information, visit <a href="http://allaboutcookies.org">AllAboutCookies.org</a>.</p>
      
      <h1>How do we use cookies?</h1>
      <p>FJData AB uses cookies in a range of ways to improve your experience on our website, including:</p>
      <ul>
        <li>Keeping your signed in, if applicable</li>
        <li>Understanding how you use our website</li>
      </ul>
      
      <h1>What types of cookies do we use?</h1>
      <p>There are a number of different types of cookies, however, our website uses:</p>
      <h2>Functionality</h2>
      <p>FJData AB uses these cookies so that we recognize you on our website and remember your previously selected preferences. These could include what language you prefer and location you are in. A mix of first-party and third-party cookies are used.</p>
      <h2>Advertising</h2>
      <p>FJData AB uses these cookies to collect information about your visit to our website, the content you viewed, the links you followed and information about your browser, device and your IP address. FJData AB sometimes shares some limited aspects of this data with third parties for advertising purposes. We may also share online data collected through cookies with our advertising partners. This means that when you visit another website, you may be shown advertising based on your browsing patterns on our website.</p>
      
      <h1>How to manage your cookies</h1>
      <p>You can set your browser to not accept cookies, and the above website tells you how to remove cookies from your browser. However, in a few cases, some of our website features may not function as a result.</p>
      
      <h1>Privacy policies of other websites</h1>
      <p>The FJData AB website contains links to other websites. Our privacy policy applies only to our website, so if you click on a link to another website, you should read their privacy policy.</p>
      
      <h1>Changes to our policy</h1>
      <p>FJData AB keeps its privacy policy under regular review and places any updates on this web page. This privacy policy was last updated on 2019-06-24.</p>
      
      <h1>How to contact us</h1>
      <p>If you have any questions about FJData AB’s privacy policy, the data we hold on you, or you would like to exercise one of your data protection rights, please do not hesitate to contact us.</p>
      <div>
        Email: <a href="mailto:contact@fjdata.se">contact@fjdata.se</a><br />
        Phone: <a hred="tel:+46(0) 723359559">+46(0) 723359559</a><br />
        Postal Address: 
        <div class="d-inline-flex align-flex-start">
          FJData AB<br />
          C/O Fredrick Johansson<br />
          Furumossen 1b<br />
          Partille<br />
          Sweden
        </div>
      </div>
      
      <h1>How to contact the appropriate authorities</h1>
      <p>Should you wish to report a complaint or if you feel that FJData AB has not addressed your concerns in a satisfactory manner, you may contact the Information Commissioner's Office.</p>
      <div>
        Website: <a href="https://www.datainspektionen.se/other-lang/in-english/">www.datainspektionen.se/other-lang/in-english/</a><br />
        Email: <a href="mailto:datainspektionen@datainspektionen.se">datainspektionen@datainspektionen.se</a><br />
        Phone: <a hred="tel:+46(0) 86576100">+46(0) 86576100</a><br />
        Postal address:
        <div class="d-inline-flex align-flex-start">
          Datainspektionen<br />
          Box 8114<br />
          104 20 Stockholm<br />
          Sweden
        </div>
      </div>
      
    </mdb-modal-body>
    
    <mdb-modal-footer class="dark-modal-footer">
      <mdb-btn rounded class="btn-rounded" color="mdb-color" @click.native="$emit('close-modal')">Close</mdb-btn>
    </mdb-modal-footer>
  </mdb-modal>
</template>

<script>
import {
  mdbModal,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalBody,
  mdbModalFooter,
  mdbBtn
} from 'mdbvue'

export default {
  name: 'PrivacyModal',
  components: {
    mdbModal,
    mdbModalHeader,
    mdbModalTitle,
    mdbModalBody,
    mdbModalFooter,
    mdbBtn
  },
  props: {
    showModal: Boolean
  },
  data() {
    return {
      
    }
  }
}
</script>

<style scoped>
.dark-modal {

}

.dark-modal-header {
  background-color: #4c525d;
}

.dark-modal-body {
  background-color: #333333;
}

.dark-modal-footer {
  background-color: #666666;
}

h1 {
  font-family: arial, 'sans-serif';
  font-size: 20px;
  color: #DEDEDE;
}

h2 {
  font-family: arial, 'sans-serif';
  font-size: 16px;
  color: #DEDEDE;
}

body,p,il,li,div {
  font-family: arial, 'sans-serif';
  font-size: 12px;
  color: #DEDEDE;
}

a,a:visited,a:active {
  text-decoration: none;
  color: #BEBEBE;
}
a:hover {
  text-decoration: none;
  color: white;
}

.summary {
  font-family: arial, 'sans-serif';
  font-size: 14px;
  font-style: italic;
  color: #BEBEBE;
}

.topic {

}
.sub-topic {

}

/* This must be copied into global scope! Fixes border bug. */

.modal-content {
  background-color: rgba(0,0,0,0);
}
/* Fix for missing funcitonality, in wait of patches. */
.btn-rounded {
  border-radius: 10em;
}
</style>